@if (parameterDataList()?.length) {
  <div [ngClass]="{ 'compact-container': isCompactMode(), '': !isCompactMode() }">
    <button mat-button (click)="onClickParameter()">View parameter</button>
  </div>
}
